import React, {useCallback, useEffect, useMemo, useState} from "react";
import { useNavigate } from "react-router-dom";
import { getLoggedInUserRole } from "../helpers/backend_helper";
import { myDataReferenceTables } from "../constants/myDataReferenceTables";

const Navdata = () => {
    const history = useNavigate();
    const [isDashboard, setIsDashboard] = useState<boolean>(false);
    const [isDocuments, setIsDocuments] = useState<boolean>(false);
    const [isMyDataAdmin, setIsMyDataAdmin] = useState<boolean>(false);
    const [isMyAccount, setIsMyAccount] = useState<boolean>(false);
    const [isMerchantAdmin, setIsMerchantAdmin] = useState<boolean>(false);
    const [isUserAdmin, setIsUserAdmin] = useState<boolean>(false);
    const [userRole, setUserRole] = useState<number>(0);
    const [iscurrentState, setIscurrentState] = useState("Dashboard");

    useEffect(() => {
        const role = getLoggedInUserRole();
        setUserRole(role || 0);
        // console.log(role);
    }, []);

    const updateIconSidebar = useCallback((e: any) => {
        if (e && e.target && e.target.getAttribute("sub-items")) {
            const ul = document.getElementById("two-column-menu");
            if (!ul) {
                return;
            }
            const iconItems: any = ul.querySelectorAll(".nav-icon.active");
            let activeIconItems = [...iconItems];
            activeIconItems.forEach((item) => {
                item.classList.remove("active");
                const id = item.getAttribute("sub-items");
                const getID = document.getElementById(id) as HTMLElement;
                if (getID) getID.classList.remove("show");
            });
        }
    }, []);

    useEffect(() => {
        document.body.classList.remove("twocolumn-panel");
        if (iscurrentState !== "Dashboard") {
            setIsDashboard(false);
        }
        if (iscurrentState !== "Documents") {
            setIsDocuments(false);
        }
        if (iscurrentState !== "MyDataAdmin") {
            setIsMyDataAdmin(false);
        }
        if (iscurrentState !== "MyAccount") {
            setIsMyAccount(false);
        }
        if (iscurrentState !== "MerchantAdmin") {
            setIsMerchantAdmin(false);
        }
        if (iscurrentState !== "UserAdmin") {
            setIsUserAdmin(false);
        }
    }, [
        history,
        iscurrentState,
        isDashboard,
        isDocuments,
        isMyDataAdmin,
        isMyAccount,
        isMerchantAdmin,
        isUserAdmin,
    ]);

    const menuItems: any = useMemo(() => [
        {
            label: "Menu",
            isHeader: true,
            access: [1,2,3],
        },
        {
            id: "dashboard",
            label: "Dashboard",
            icon: "ri-dashboard-2-line",
            link: "/#",
            access: [1,2,3],
            stateVariables: isDashboard,
            click: function (e: any) {
                e.preventDefault();
                setIsDashboard((value) => !value);
                setIscurrentState('Dashboard');
                updateIconSidebar(e);
            },
        },
        {
            id: "documents",
            label: "Παραστατικά",
            icon: "ri-article-line",
            link: "/#",
            access: [1,2,3],
            stateVariables: isDocuments,
            click: function (e: any) {
                e.preventDefault();
                setIsDocuments((value) => !value);
                setIscurrentState('Documents');
                updateIconSidebar(e);
            },
            subItems: [
                {
                    id: "documents-all",
                    label: "Προβολή όλων",
                    link: "/documents/documents-all",
                    parentId: "documents",
                    access: [1,2,3],
                },
                {
                    id: "offline-submit",
                    label: "Offline καταχώρηση",
                    link: "/documents/offline",
                    parentId: "documents",
                    access: [1,3],
                },
                // {
                //     id: "search",
                //     label: "Αναζήτηση",
                //     link: "/documents/search",
                //     parentId: "documents",
                //     access: [1,2,3],
                // },
                {
                    id: "pending",
                    label: "Pendings",
                    link: "/documents/pending",
                    parentId: "documents",
                    access: [1,2,3],
                },
                {
                    id: "failed",
                    label: "Failed",
                    link: "/documents/failed",
                    parentId: "documents",
                    access: [1,3],
                },
                {
                    id: "signatures",
                    label: "Signatures",
                    link: "/documents/signatures",
                    parentId: "documents",
                    access: [1,2,3],
                },
            ]
        },
        {
            id: "my-account",
            label: "Η Εταιρία μου ",
            icon: "ri-building-4-line",
            link: "/#",
            access: [3],
            stateVariables: isMyAccount,
            click: function (e: any) {
                e.preventDefault();
                setIsMyAccount((value) => !value);
                setIscurrentState('MyAccount');
                updateIconSidebar(e);
            },
            subItems: [
                {
                    id: "merchant-api",
                    label: "Προβολή όλων",
                    link: "/merchants/me",
                    parentId: "my-account",
                    access: [3],
                },
                // {
                //     id: "merchant-branches",
                //     label: "Σημεία Εξυπηρέτησης",
                //     link: "/merchants/locations",
                //     parentId: "my-account",
                //     access: [3],
                // },
            ]
        },
        {
            id: "merchant-admin",
            label: "Merchants",
            icon: "ri-building-4-line",
            link: "/#",
            access: [1,2],
            stateVariables: isMerchantAdmin,
            click: function (e: any) {
                e.preventDefault();
                setIsMerchantAdmin((value) => !value);
                setIscurrentState('MerchantAdmin');
                updateIconSidebar(e);
            },
            subItems: [
                {
                    id: "merchant-api",
                    label: "Προβολή όλων",
                    link: "/merchants",
                    parentId: "merchant-admin",
                    access: [1,2],
                },
            ]
        },
        {
            id: "user-admin",
            label: "Management",
            icon: "ri-group-line",
            link: "/#",
            access: [1],
            stateVariables: isUserAdmin,
            click: function (e: any) {
                e.preventDefault();
                setIsUserAdmin((value) => !value);
                setIscurrentState('UserAdmin');
                updateIconSidebar(e);
            },
            subItems: [
                {
                    id: "users-api",
                    label: "Users",
                    link: "/users",
                    parentId: "user-admin",
                    access: [1],
                },
                {
                    id: "merchant-credits",
                    label: "Credits",
                    link: "/merchants/credits",
                    parentId: "user-admin",
                    access: [1],
                },
                {
                    id: "api",
                    label: "API",
                    link: "/api",
                    target: "_blank",
                    parentId: "user-admin",
                    access: [1],
                },
            ]
        },
        {
            id: "mydata-admin",
            label: "myData",
            icon: "ri-database-2-line",
            link: "/#",
            access: [1],
            stateVariables: isMyDataAdmin,
            click: function (e: any) {
                e.preventDefault();
                setIsMyDataAdmin((value) => !value);
                setIscurrentState('MyDataAdmin');
                updateIconSidebar(e);
            },
            subItems: [
                ...myDataReferenceTables.map((table) => ({
                    id: `mydata-${table.key}`,
                    label: table.title,
                    link: table.key === 'invoice-types' ? "/documents/types" : `/mydata/reference-tables/${table.key}`,
                    parentId: "mydata-admin",
                    access: [1],
                })),
                {
                    id: "mydata-api-test-templates",
                    label: "myData Test Templates",
                    link: "/mydata-api-test-templates",
                    parentId: "mydata-admin",
                    access: [1],
                },
                {
                    id: "mydata-api-tests",
                    label: "myData API Tests",
                    link: "/mydata-api-tests",
                    parentId: "mydata-admin",
                    access: [1],
                },
            ],
        }
        // Additional menu items...
    ], [
        isDashboard,
        isDocuments,
        isMyDataAdmin,
        isMyAccount,
        isMerchantAdmin,
        isUserAdmin,
        updateIconSidebar,
    ]);

    const filteredMenuItems = useMemo(() => menuItems
        .filter((item: any) => item.access.includes(userRole))
        .map((item: any) => {
            if (item.subItems) {
                return {
                    ...item,
                    subItems: item.subItems.filter((subItem: any) =>
                        subItem.access.includes(userRole)
                    ),
                };
            }
            return item;
        }), [menuItems, userRole]);

    return <React.Fragment>{filteredMenuItems}</React.Fragment>;
};

export default Navdata;
